import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { AgreementsModel } from 'src/app/shared/models/agreements.model';
import { ContactModel } from 'src/app/shared/models/contact.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ProductsService } from 'src/app/shared/services/products/products.service';

@Component({
  selector: 'app-agreements-filter',
  templateUrl: './agreements-filter.component.html',
  styleUrls: ['./agreements-filter.component.scss'],
})
export class AgreementsFilterComponent implements OnInit {
  productsSelectedMulti: any;
  phase: any[];
  formGroup: FormGroup;
  options: AgreementsModel[];
  options2: AgreementsModel[];
  offices: any = [];
  showOptions: boolean;
  selectedAgreement: AgreementsModel;
  reactiveErrorAgreement: string;
  contactInfo: ContactModel;
  filter_offices: any = [];
  code_product: any;
  stringSearch = '';

  constructor(
    private bioCatchService: BioCatchService,
    public copyService: CopyService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private formBuilder: FormBuilder,
    private productService: ProductsService,
  ) {
    this.headerService.show(true, false, true);
    this.formGroup = this.formBuilder.group({});
    this.showOptions = false;
  }

  /**
   * Summary initial event, customer information
   */
  ngOnInit(): void {
    const product = this.abreCuentasService.getproductSelected()
      .product_code as ProductsBiocatchEnum;
    console.log('product', product);
    this.bioCatchService.changeContext(
      StepBiocatchEnum.solicitud,
      product,
      !this.abreCuentasService.getPostlogin(),
      !this.abreCuentasService.getPostlogin(),
    );
    this.code_product = this.abreCuentasService.getproductSelected().code;
    this.formGroup = new FormGroup({
      'input-value-agreement': new FormControl('', [Validators.required]),
    });
    this.options = this.abreCuentasService.getAgreementList();
    this.options2 = this.abreCuentasService.getAgreementList();
    if (this.abreCuentasService.getAgreementSelected() !== undefined) {
      this.selectedAgreement = this.abreCuentasService.getAgreementSelected();
      return;
    }
    this.selectedAgreement = {
      agreement_code: '0',
      agreement_name: '',
      agreement_id: '',
      transaction_type: 'false',
      description: '',
      row_id: '',
      document_number: '',
      client_name: '',
      client_nit: '',
      agreement_number: '',
    };
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOption(option: any) {
    if (!option.value) {
      this.selectedAgreement = {
        agreement_code: '0',
        agreement_name: '',
        agreement_id: '',
        transaction_type: 'false',
        description: '',
        row_id: '',
        document_number: '',
        client_name: '',
        client_nit: '',
        agreement_number: '',
      };
      return;
    }
    this.showOptions = false;
    this.selectedAgreement = option.value;
    this.formGroup.controls['input-value-agreement'].setValue(option.description);
    this.abreCuentasService.setAgreementSelected(this.selectedAgreement);
  }

  /**
   * Summary next event validation
   */
  next() {
    const code = this.abreCuentasService.getproductSelected().code;
    if (code === '201' || code === '203') {
      const body = {
        data: {
          client_agreement_code: this.selectedAgreement.agreement_code,
        },
      };
      this.productService.offersSelectAgreement(body).then(
        (response: any) => {
          if (!response) {
            return;
          }
          if (response.statusCode === 500) {
            this.navigationService.navigateToGeneralInformation('500');
            return;
          }
          this.navigationService.nextStep('200');
        }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
    }
    if (code === '999' || code === '232') {
      this.productService.AgreementDetail(this.selectedAgreement.agreement_number)
        .then((response: any) => {
          this.abreCuentasService.setAgreementDetailSelected(response.data);
          console.log('gettAgreementDetailSelected', this.abreCuentasService.getAgreementDetailSelected());

          this.navigationService.nextStep('200');

        }).catch(error => {
          console.log(error),
            this.navigationService.navigateToGeneralInformation('500');
        });
    }

  }

  onChangeSearch(event: string) {
    if (event === '') {
      const option = {
        value: '',
      };
      this.selectOption(option);
    }
  }

}
